import { Component, computed, Input, OnInit } from '@angular/core';
import {
  WagtailButtonRendererInterface,
  WagtailPageContentElementInterface
} from "@gea-waldviertler-website/gea-models";
import { ActivatedRoute } from "@angular/router";
import { scrollToFirstEl } from "../../../helpers";

@Component({
    selector: 'wagtail-page-element-button',
    templateUrl: './button.component.html',
    standalone: false
})
export class WagtailButtonComponent implements OnInit {
  @Input() definition?: WagtailPageContentElementInterface<WagtailButtonRendererInterface>
  content?: WagtailButtonRendererInterface
  cssClass: string = 'btn-green form-control'
  onClick?: (e: MouseEvent) => void

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    if (this.definition) {
      if (this.definition.value.cssClass) {
        this.cssClass = this.definition.value.cssClass
      }
      this.content = this.mutateAnchor(this.definition.value)
    }
  }

  href = computed(() => {
    if (! this.definition) return 'javascript:void()'
    const currentPath = this.route.snapshot.url.join('/')
    const linkParts = this.definition.value.url.split('#')

    // if current page is linked, create onClick-handler
    if ((currentPath == linkParts[0] || ('/shop/' + currentPath) == linkParts[0] || linkParts[0] == "") && linkParts.length == 2) {
      return '#!'
    }

    return this.definition.value.url
  })

  private mutateAnchor(definition: WagtailButtonRendererInterface): WagtailButtonRendererInterface {
    const currentPath = this.route.snapshot.url.join('/')
    const linkParts = definition.url.split('#')

    // if current page is linked, create onClick-handler
    if ((currentPath == linkParts[0] || ('/shop/' + currentPath) == linkParts[0] || linkParts[0] == "") && linkParts.length == 2) {
      this.onClick = (e: MouseEvent)=> {
        e.preventDefault()
        scrollToFirstEl('#' + linkParts[1])
      }
    }

    return definition
  }
}
